import { Component, Inject, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { AuthContract } from "../../shared/contracts/auth.contract";
import { LocalizationModule } from "../localization";

@Component({
  selector: "app-get-started-dialog",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatSelectModule,
    LocalizationModule,
  ],
  templateUrl: "./get-started-dialog.component.html",
  styleUrls: ["./get-started-dialog.component.scss"],
})
export class GetStartedDialogComponent {
  form: FormGroup;
  success: boolean = false;
  labelMap: any;

  public interestOptions: any = [];

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<GetStartedDialogComponent>,
    private authContract: AuthContract,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      name: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      interest: ["", [Validators.required]],
      message: ["", Validators.required],
    });
    this.labelMap = data.labelMap;

    this.interestOptions = [
      { id: "athleteTracking", label: this.labelMap.GET_STARTED_INTEREST_1 },
      { id: "studioManagement", label: this.labelMap.GET_STARTED_INTEREST_2 },
      { id: "eventManagement", label: this.labelMap.GET_STARTED_INTEREST_3 },
      { id: "memberships", label: this.labelMap.GET_STARTED_INTEREST_4 },
      { id: "federation", label: this.labelMap.GET_STARTED_INTEREST_5 },
      { id: "ticketSales", label: this.labelMap.GET_STARTED_INTEREST_6 },
      {
        id: "banquetsAndSeminars",
        label: this.labelMap.GET_STARTED_INTEREST_7,
      },
    ];
  }

  onSubmit() {
    if (this.form.valid) {
      // Process form data here
      const interestId = this.form.value.interest;
      let interestValue = this.interestOptions
        .filter((value: any) => value.id === this.form.value.interest)
        .pop();

      let joinUserData = {
        name: this.form.value.name,
        email: this.form.value.email,
        message: this.form.value.message,
        interest: interestValue?.label,
      };
      this.authContract.joinToUventex(joinUserData).subscribe(
        (userData) => {
          console.log("Request sent: ", userData);
        },
        (error) => {
          const message = error.error.message;
          // const title = this.transloco.translate('REGISTRATION_NOT_FINISHED');
          // this.toastr.warning(message, title, { closeButton: true });
        }
      );

      console.log("Form Submitted", this.form.value, interestValue);
      this.success = true;
    } else {
      // Mark all fields as touched to show errors
      this.form.markAllAsTouched();
    }
  }

  isFieldInvalid(field: string): boolean | undefined {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.touched || this.form.get(field)?.dirty)
    );
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
